export const ANNOUNCEMENT_STATUSES = ['draft', 'scheduled', 'published', 'ended']
export const ANNOUNCEMENT_PLACEMENTS = ['modal', 'bottomSheet', 'banner']
export const ANNOUNCEMENT_ACTION_TYPES = ['route', 'externalUrl', 'dismiss']
export const ANNOUNCEMENT_DISPLAY_RULES = ['once', 'oncePerVersion', 'oncePerDay']
export const ADMIN_REPORT_STATUSES = ['new', 'reviewing', 'resolved', 'rejected']
export const STORED_REPORT_STATUS = { new: 'pending', pending: 'pending', reviewing: 'reviewing', resolved: 'resolved', rejected: 'rejected' }

export const EMPTY_ANNOUNCEMENT = {
  title: '', description: '', imageUrl: '', status: 'draft', placement: 'modal',
  actionLabel: '', actionType: 'dismiss', actionTarget: '', startAt: '', endAt: '',
  minAppVersion: '', maxAppVersion: '', targetPlatforms: ['ios', 'android', 'web'],
  displayRule: 'once', priority: 0,
}

export const NOTIFICATION_CATEGORIES = [
  { id: 'reportCreated', label: '신규 사용자 제보' },
  { id: 'publishFailed', label: '앱 내 안내 게시 실패' },
  { id: 'validationFailed', label: '데이터 검증 실패' },
]

// admins/{uid} 문서와 custom claim(adminRole)이 공유하는 4단계 권한 모델.
// owner: 관리자·권한·시스템 포함 전체 권한 / admin: 운영 데이터 전체 관리(다른 관리자 권한 변경 불가)
// editor: 콘텐츠·제보 등 허용된 도메인만 수정 / viewer: 읽기 전용
export const ADMIN_ROLES = ['owner', 'admin', 'editor', 'viewer']
export const ADMIN_ROLE_RANK = { viewer: 0, editor: 1, admin: 2, owner: 3 }
export const ADMIN_ROLE_LABELS = { owner: 'Owner', admin: 'Admin', editor: 'Editor', viewer: 'Viewer' }

export const EMPTY_ADMIN_ACCOUNT = { role: 'viewer', enabled: true, displayName: '' }
